import React from "react";
import { Checkbox } from "components/common";
import { LegalLink, LEGAL_LINK_TYPES } from "./LegalLink";

const LegalAgreementBody = ({ textClassName, linkClassName }) => (
  <div className={textClassName}>
    By continuing, I certify that I am 18 years of age or older, and I agree to
    the{" "}
    <LegalLink
      type={LEGAL_LINK_TYPES.TERMS_OF_USE}
      className={linkClassName}
    />
    ,{" "}
    <LegalLink
      type={LEGAL_LINK_TYPES.PRIVACY_POLICY}
      className={linkClassName}
    />
    , and <LegalLink type={LEGAL_LINK_TYPES.ESIGN} className={linkClassName} />
    . I consent to receive texts, emails, and phone calls for account
    notifications and marketing. Message frequency may vary and you may opt out
    by responding STOP or HELP for more information. Message and data rates may
    apply.
  </div>
);

export const LegalAgreement = ({
  containerClassName,
  checkboxClassName,
  textClassName,
  linkClassName,
  termsAccepted,
  setTermsAccepted,
}) => {
  return (
    <div className={containerClassName}>
      <Checkbox
        className={checkboxClassName}
        labelComponent={
          <LegalAgreementBody
            textClassName={textClassName}
            linkClassName={linkClassName}
          />
        }
        checked={termsAccepted}
        onChange={(e) => setTermsAccepted?.(e.target.checked)}
      />
    </div>
  );
};
